import { Box, ChipProps, Stack, SvgIconProps } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import { C1Chip } from 'c1ui/components/C1Chip'
import { ObjectDisplayStyles } from 'components/core/display-name-details/display/styles'
import { C1DrawerLink } from 'components/core/drawer_link'
import { C1TextWithTruncation } from 'components/core/TextWithTruncation/C1TextWithTruncation'
import React from 'react'

export type MetadataPropType = [MetadataStringIconPair?, MetadataStringIconPair?]
export type MetadataStringIconPair = { text: string, icon?: React.ReactElement<SvgIconProps> }

export type C1ObjectDisplayProps = {
    avatar?: React.ReactNode
    title: string
    titleVariant?: Variant
    metadata?: MetadataPropType
    identifier?: ChipProps
    drawerContent?: React.ReactElement
    isDeleted?: boolean
}

const DisplayTitle = ({
    title,
    titleVariant,
    drawerContent,
}: Pick<
    C1ObjectDisplayProps,
    'title' | 'titleVariant' | 'drawerContent'
>): React.ReactElement => {
    if (drawerContent) {
        return (
            <C1DrawerLink label={title} drawerContent={drawerContent} linkVariant="dashed" />
        )
    }
    return <C1TextWithTruncation variant={titleVariant} text={title} />
}

export const Metadata: React.FC<{ metadata?: MetadataPropType }> = ({ metadata }) => {
    if (!metadata) {
        return null
    }

    return (
        <Stack direction="row" sx={{ alignItems: 'center' }}>
            {metadata[0] && (<>
                <Box component="span" sx={{ minWidth: '20px' }}>
                    <C1TextWithTruncation
                        text={metadata[0].text}
                        textStyles={ObjectDisplayStyles.metadata}
                    />
                </Box>
                {metadata[0]?.icon && (
                    <Box component="span" sx={{ paddingLeft: '2px' }}>
                        {metadata[0].icon}
                    </Box>
                )}
            </>
            )}
            {metadata[1] &&
                (<>
                    <Box component="span" sx={{ marginRight: '2px', marginLeft: '2px' }}>
                        ·
                    </Box>
                    <Box component="span" sx={{ flex: 1, maxWidth: '400px' }}>
                        <C1TextWithTruncation
                            text={metadata[1].text}
                            textStyles={ObjectDisplayStyles.metadata}
                        />
                    </Box>
                    {metadata[1]?.icon && (
                        <Box component="span" sx={{ paddingLeft: '2px' }}>
                            {metadata[1].icon}
                        </Box>
                    )}
                </>)
            }

        </Stack>
    )
}

/**
 * @deprecated Use DisplayNameDetails instead
 */
export const C1ObjectDisplay = ({
    title,
    titleVariant,
    avatar,
    metadata,
    identifier,
    drawerContent,
    isDeleted,
}: C1ObjectDisplayProps): React.ReactElement => {
    return (
        <Stack direction="row" alignItems="center">
            {avatar && <Box sx={{ marginRight: 2 }}>{avatar}</Box>}
            <Stack sx={{ overflow: 'hidden' }}>
                <Stack direction="row" sx={{ alignItems: 'center' }}>
                    <DisplayTitle
                        title={title}
                        titleVariant={titleVariant}
                        drawerContent={drawerContent}
                    />
                    {identifier && identifier.label && <C1Chip label={identifier.label} color={identifier.color} />}
                </Stack>
                {metadata && metadata.length > 0 && <Metadata metadata={metadata} />}
            </Stack>
            {isDeleted && (
                <Box>
                    <C1Chip color="error" label="Deleted" />
                </Box>
            )}
        </Stack>
    )
}
